import React from "react";

const IconWithBackground = ({ children, backgroundColor = "" }) => {
  return (
    <div
      style={{
        width: "32px",
        height: "32px",
        borderRadius: "50%",
        background: backgroundColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "8px",
    
      }}
    >
      {children}
    </div>
  );
};

export default IconWithBackground;